import { Col, ConfigProvider, Row, Select } from "antd";
import React, { Component } from "react";
import { connect } from 'react-redux';
import AlertBox from "../../../../../CommonComponents/AlertBox";
import BreadcrumbComponent from "../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { FixedWidth, ErrorMessage, PagesHeading } from "../../../../../CommonComponents/commonStyles";
import { ContentMessage, Types } from "../../../../../CommonComponents/ContentMessages";
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import { flushZipCode } from "../../../../../CommonComponents/Zipcode/actions";
import history from '../../../../../history/history';
import { initiateTracking, recordError } from "../../../../../utils/commonUtil";
import regexMap from '../../../../../utils/regexMap';
import { getPrimaryAccount, isGeminiUser } from '../../../../../utils/sessionUtil';
import { gaClearAllFilters, gaClearAllGeminiFilters } from '../../GrantAgreement/actions';
import { addToSavedCharity, changeEinPopUpStatus, clearCharityList, clearValidation, receiveDropDownValues, postCharity, validateFields } from '../actions';
import { AboutCharity, AddrDetail, AddresstTitle, CharityDetailsHeading, CharityInput, CharityLabel, CharityZipcode, Detail, Groups, Limiter, NoLabel, Note, NoWarning, SACContainer, SACTitle, SelectBox, Warning } from "../style";
import AddCharityMobile from './AddCharityMobile';
import AddCharityWeb from './AddCharityWeb';
import PropTypes from 'prop-types';
import { suggestAcharityDerivedStates } from "../selectors";
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";
const Option = Select.Option;

let suggestFields = {
  cname: "",
  ein: "",
  addr1: "",
  addr2: "",
  addr3: "",
  zipcode: "",
  country: "0",
  stateInput: "",
  city: "",
  selectType: "",
  email: "",
  contactName: '',
  firstName: '',
  lastName: '',
  contactInfo: ''
}

class SuggestACharity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cname: "",
      ein: "",
      addr1: "",
      addr2: "",
      addr3: "",
      zipcode: "",
      country: "0",
      countryName: 'United States',
      state: "",
      city: "",
      selectType: "",
      typeControl: "",
      selectCountry: "",
      email: "",
      contactName: '',
      firstName: '',
      lastName: '',
      countryList: [],
      abbrMapper: [],
      contactInfo: "",
      showStateInput: false,
      showPopUp: false,
      showEinPopUp: false,
      showMulEinPopUp: false,
      isPost: true,
      isSuccess: false,
      loader: false,
      recommandGrant: (isConfirm = false) => {
        if (!isConfirm) {
          initiateTracking("back2", this.props.getPageTitle(), '', this.props.backBtnText)
        }
        this.goBack();
      },
      err: {
        cname: "",
        ein: "",
        addr1: "",
        zipcode: "",
        country: "0",
        state: "",
        city: "",
        contactName: "",
        firstName: '',
        lastName: '',
        charityContact: "",
        checkContact: "",
        selectType: ""
      }
    };
    this.handlecName = this.handlecName.bind(this);
    this.handleEIN = this.handleEIN.bind(this);
    this.handleAddr = this.handleAddr.bind(this);
    this.handleAddr2 = this.handleAddr2.bind(this);
    this.handleAddr3 = this.handleAddr3.bind(this);
    this.handlezip = this.handlezip.bind(this);
    this.handleCity = this.handleCity.bind(this);
    this.handleDropper = this.handleDropper.bind(this);
    this.handleContact = this.handleContact.bind(this);
    this.handleCountry = this.handleCountry.bind(this);
    this.handleStates = this.handleStates.bind(this);
    this.handleFirstName = this.handleFirstName.bind(this);
    this.handleLastName = this.handleLastName.bind(this);
    this.validation = this.validation.bind(this);
    this.handleStateInput = this.handleStateInput.bind(this);
    this.suggestCharity = this.suggestCharity.bind(this);
    this.charityName = React.createRef();
    this.addr1 = React.createRef();
    this.city = React.createRef();
    this.stateInput = React.createRef();

    this.contactPopUp = {
      heading: "Alert",
      line1: "<p>Not mentioning contact details may result in a longer processing time.</p><p>Do you want to continue?</p>",
      continue: "Continue",
      cancel: "Cancel"
    };

    this.einPopUp = {
      heading: "Alert",
      line1: "<p>An EIN match has been identified.</p><p>Do you want to select the one that's already existing?</p>",
      continue: "Continue",
      cancel: "Cancel"
    };

    this.einMulPopUp = {
      heading: "Alert",
      line1: "<p>The charity you selected has multiple locations or divisions.</p><p>Please make your selection by clicking \"Add Charity\".</p>",
      continue: "Continue"
    }
  }

  componentDidMount() {
    const data = {
      metaData: {
        method: "GET",
        page: "Sac",
        url: "/donor-portal/api/dropDownValues/getCodeValueMapping"
      }
    }
    suggestFields = {
      cname: "",
      ein: "",
      addr1: "",
      addr2: "",
      addr3: "",
      zipcode: "",
      country: "0",
      stateInput: "",
      city: "",
      selectType: "",
      email: "",
      contactName: '',
      firstName: '',
      lastName: '',
      contactInfo: ''
    }
    window.scrollTo(0, 0);
    this.props.getDropDownMapping(data);
    this.props.clearValidation(false);
  }

  getSnapshotBeforeUpdate(oldProps) {
    const { suggestPost, savedCharity } = this.props;
    if (savedCharity && oldProps.savedCharity !== savedCharity) {
      history.push({
        pathname: '/grants/find-charity',
        state: {
          ein: this.state.ein
        }
      });
    }

    if (suggestPost && suggestPost.isExisting === true && suggestPost.showEinPopUp === true) {
      this.props.changeEinPopUpStatus(suggestPost);
      if (!suggestPost.granteeOrgs || (suggestPost.granteeOrgs && suggestPost.granteeOrgs.length === 1)) {
        this.setState({
          isPost: false,
          showEinPopUp: true,
          isSuccess: false,
          loader: false
        });
      } else if (suggestPost.granteeOrgs.length > 1) {
        this.setState({
          isPost: false,
          showMulEinPopUp: true,
          isSuccess: false,
          loader: false
        });
      }
    } else if (suggestPost && suggestPost.isExisting === false && suggestPost.showEinPopUp === false) {
      this.props.changeEinPopUpStatus(suggestPost);
      this.setState({
        isSuccess: true,
        loader: false
      }, () => {
        this.props.validate(this.state);
      })
    }
    return null;
  }

  clearCharityList = () => {
    this.setState({ isPost: true }, () => {
      this.props.clearCharityList('');
    })
  }

  //functions Validators
  handlecName = function (e) {
    const value = e.target.value ? e.target.value.trim() : '';
    if (value.length === 0) {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          cname: "Please enter charity name."
        }
      }));
    } else if (value.length < 2) {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          cname: "Charity name is too short."
        }
      }));
    }
    else if (value && value.length <= 150) {
      this.setState({ cname: value });
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          cname: ""
        }
      }));
    }
  };

  handlezip = function (e) {
    const value = e.target.value ? e.target.value.trim() : '';
    const { country } = this.state;
    if (!value) {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          zipcode: "Please enter zip code."
        }
      }));
    } else if (country.toString() === '0' && !regexMap.uszipCode.test(value)) {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          zipcode:
            "The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue."
        }
      }));
    } else if (value.length <= 20) {
      this.setState({ zipcode: value });
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          zipcode: ""
        }
      }));
    }
  };

  handleAddr = function (e) {
    const addr1 = this.addr1.current.state.value ? this.addr1.current.state.value.trim() : '';
    if (!addr1) {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          addr1: "Please enter address."
        }
      }));
    } else if (addr1 && addr1.length <= 50) {
      this.setState({ addr1: addr1 });
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          addr1: ""
        }
      }));
    }
  };

  handleAddr2 = function (e) {
    const addr2 = e.target.value ? e.target.value.trim() : '';
    if (addr2 && addr2.length <= 50) {
      this.setState({ addr2 });
    }
  };

  handleAddr3 = function (e) {
    const addr3 = e.target.value ? e.target.value.trim() : '';
    if (addr3 && addr3.length <= 50) {
      this.setState({ addr3 });
    }
  };

  handleFirstName = (e) => {
    const contactName = e.target.value ? e.target.value.trim() : '';
    if (contactName) {
      if (contactName.length <= 100) {
        this.setState({ firstName: contactName });
        return this.setState(prevState => ({
          err: {
            ...prevState.err,
            firstName: '',
          },
        }));
      }
    } else if (this.state.lastName) {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          firstName: `Please enter first name.`
        }
      }));

    } else {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          firstName: '',
        },
      }));
    }

  };

  handleLastName = (e) => {
    const contactName = e.target.value ? e.target.value.trim() : '';
    if (contactName) {
      if (contactName.length <= 100) {
        this.setState({ lastName: contactName });
        return this.setState(prevState => ({
          err: {
            ...prevState.err,
            lastName: '',
          },
        }));
      }
    } else if (this.state.firstName) {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          lastName: 'Please enter last name.',
        },
      }));
    } else {
      return this.setState(prevState => ({
        err: {
          ...prevState.err,
          lastName: '',
        },
      }));
    }
  };

  handleCity = function (e) {
    const city = this.city.current.state.value ? this.city.current.state.value.trim() : '';
    if (!city) {
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          city: "Please enter city."
        }
      }));
    } else if (city.length < 3) {
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          city: "City name is too short. Please correct to continue."
        }
      }));
    } else if (city.length <= 100 && regexMap.city.test(city)) {
      this.setState({ city: city });
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          city: ""
        }
      }));
    }
  };

  handleDropper(value) {
    this.setState({ selectType: value, contactInfo: '' });
    this.validation(value, 'selectType');
  }

  handleContact(e) {
    const value = e.target.value ? e.target.value.trim() : '';
    if (this.state.firstName || this.state.lastName || this.state.selectType) {
      if (!this.state.selectType && !value) {
        this.setState(prevState => ({
          err: {
            ...prevState.err,
            charityContact: "Please select the charity contact details."
          },
          checkContact: false
        }));

      } else if (this.state.selectType === "Phone") {
        if (!value) {
          this.setState(prevState => ({
            err: {
              ...prevState.err,
              charityContact: "Please enter phone number."
            },
            checkContact: false
          }));
        }
        else if (!regexMap.phone.test(value)) {
          this.setState({ contactInfo: "" });
          this.setState(prevState => ({
            err: {
              ...prevState.err,
              charityContact: "Please enter a valid phone number."
            },
            checkContact: false
          }));
        } else {
          this.setState({ contactInfo: value });
          this.setState(prevState => ({
            err: {
              ...prevState.err,
              charityContact: ""
            },
            checkContact: "Phone"
          }));
        }
      }
      else if (this.state.selectType === "Email") {
        if (!value) {
          this.setState(prevState => ({
            err: {
              ...prevState.err,
              charityContact: "Please enter email address."
            },
            checkContact: false
          }));
        }
        else if (!regexMap.emailRegEx.test(value)) {
          this.setState({ contactInfo: e.target.value });
          this.setState(prevState => ({
            err: {
              ...prevState.err,
              charityContact: "Please enter a valid email address."
            },
            checkContact: false
          }));
        } else {
          this.setState({ contactInfo: value });
          this.setState(prevState => ({
            err: {
              ...prevState.err,
              charityContact: ""
            },
            checkContact: "Email"
          }));
        }
      }
    } else {
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          charityContact: ""
        },
        checkContact: ""
      }));
    }
  }

  handleEIN(e) {
    const value = e.target.value ? e.target.value.trim() : '';
    if (value && value.length < 2) {
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          ein: "The EIN is too short."
        }
      }));
    }
    else if (value && !regexMap.einRegex.test(value)) {
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          ein: "The EIN must be in one of the following two formats: xxxxxxxxx or xx-xxxxxxx. Please correct to continue."
        }
      }));
    } else {
      this.setState({ ein: value });
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          ein: ""
        }
      }));
    }
  }

  resetAddress(value = '') {
    if (this.state.showStateInput) this.stateInput.current.state.value = '';
    if (value) {
      this.setState({
        showStateInput: value !== '0',
        zipcode: ''
      })
      suggestFields['zipcode'] = '';
    }
    this.setState(prevState => ({
      state: '',
      city: '',
      err: {
        ...prevState.err,
        state: '',
        zipcode: '',
        city: ''
      }
    }));
    this.city.current.state.value = '';
    suggestFields['stateInput'] = '';
    suggestFields['city'] = '';
    this.props.flushZipCode();
  }

  handleCountry = value => {
    const { countryList } = this.props;
    const countryName = countryList ? countryList.find(c => c.value === value) : {};
    this.resetAddress(value);
    this.validation(value, 'country');
    if (countryName && countryName.hasOwnProperty('desc'))
      this.setState({ countryName: countryName.desc });
    this.setState({ country: value });
  };

  handleStates = value => {
    this.setState({ state: value });
    this.validation(value, 'stateInput');
  };

  handleSelectBlur = (value, field) => {
    switch (field) {
      case "state":
        if (!value) this.setState(prevState => ({
          err: {
            ...prevState.err,
            state: "Please enter state."
          }
        }))
        else this.setState(prevState => ({
          err: {
            ...prevState.err,
            state: ""
          }
        }))
        break;
      case "selectType":
        if (!value && (this.state.firstName || this.state.lastName)) this.setState(prevState => ({
          err: {
            ...prevState.err,
            selectType: "Please select the charity contact type."
          }
        }))
        else this.setState(prevState => ({
          err: {
            ...prevState.err,
            selectType: ""
          }
        }))
        break;
    }
  }

  handleStateInput(e) {

    const value = e.target.value ? e.target.value.trim() : '';
    if (!value) {
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          state: "Please enter state."
        }
      }));
    } else if (value.length < 2) {
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          state: "State name is too short."
        }
      }));
    } else if (value.length <= 100 && regexMap.state.test(value)) {
      this.setState({ state: e.target.value });
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          state: ""
        }
      }));
    }
  }

  componentDidUpdate = (oldPros) => {
    if (JSON.stringify(oldPros.zipCodeData) !== JSON.stringify(this.props.zipCodeData)) {
      const { zipCodeData, statesList } = this.props;
      if (this.state.country === '0' && this.props.zipCodeData && zipCodeData && zipCodeData.zipcode) {
        let state = statesList && zipCodeData.zipcode.state && statesList.find(i => i.desc.toLowerCase() === zipCodeData.zipcode.state.toLowerCase());
        this.setState({
          city: zipCodeData.zipcode.city,
          state: state ? state.value : null
        }, () => {
          suggestFields['city'] = zipCodeData.zipcode.city;
          suggestFields['stateInput'] = state ? state.value : null;
          this.props.validateFields(suggestFields)
        })
      }
    }
  }

  //Final submission
  validation(value, field) {
    if (field === 'cname' && value.length <= 150) {
      this.setState({
        cname: value
      }, () => {
        suggestFields[field] = value
        this.props.validateFields(suggestFields);
      });
    } else if (field === 'ein') {
      if (regexMap.zipcode.test(value) && ((value.includes('-') && value.length <= 10) || (!value.includes('-') && value.length <= 9))) {
        this.setState({
          ein: value
        }, () => {
          suggestFields[field] = value
          this.props.validateFields(suggestFields);
        });
      }
    } else if (field === 'addr1' && value.length <= 50) {
      this.setState({
        addr1: value
      }, () => {
        suggestFields[field] = value
        this.props.validateFields(suggestFields);
      });

    } else if (field === 'addr2' && value.length <= 50) {
      this.setState({
        addr2: value
      }, () => {
        suggestFields[field] = value
        this.props.validateFields(suggestFields);
      });
    } else if (field === 'addr3' && value.length <= 50) {
      this.setState({
        addr3: value
      }, () => {
        suggestFields[field] = value
        this.props.validateFields(suggestFields);
      });
    } else if (field === 'zipcode') {
      if (this.state.country.toString() === '0') {
        if (!regexMap.uszipCode.test(value)) {
          this.resetAddress();
        }
        if (regexMap.zipcode.test(value) && value.length <= 20) {
          this.setState({
            zipcode: value
          }, () => {
            suggestFields[field] = value
            this.props.validateFields(suggestFields);
          });
        }
      } else if (value.length <= 20) {
        this.setState({
          zipcode: value
        }, () => {
          suggestFields[field] = value
          this.props.validateFields(suggestFields);
        });
      }
    } else if (field === 'country') {
      suggestFields[field] = value;
      this.props.validateFields(suggestFields);
    } else if (field === "stateInput") {
      if (value.length <= 100 && regexMap.state.test(value)) {
        this.setState({
          state: value
        }, () => {
          suggestFields[field] = value
          this.props.validateFields(suggestFields);
        });
      }
    } else if (field === 'city' && value.length <= 100 && regexMap.city.test(value)) {
      this.setState({
        city: value
      }, () => {
        suggestFields[field] = value
        this.props.validateFields(suggestFields);
      });

    } else if (field === 'firstName' && value.length <= 100) {
      this.setState({
        firstName: value
      }, () => {
        suggestFields[field] = value
        this.props.validateFields(suggestFields);
      });
      if (value.length == 0) {
        this.setState(prevState => ({
          err: {
            ...prevState.err,
            lastName: '',
            charityContact: '',
            checkContact: '',
            selectType: ''
          }
        }))
      }
    } else if (field === 'lastName' && value.length <= 100) {
      this.setState({
        lastName: value
      }, () => {
        suggestFields[field] = value
        this.props.validateFields(suggestFields);
      });
    } else if (field === "contactInfo") {
      if (this.state.selectType && this.state.selectType === "Phone") {
        if (value.length <= 25 && regexMap.phone.test(value)) {
          this.setState({
            contactInfo: value
          }, () => {
            suggestFields['selectType'] = 'Phone';
            suggestFields[field] = value;
            this.props.validateFields(suggestFields);
          });
        }
      } else if (this.state.selectType && this.state.selectType === "Email") {
        if (value.length <= 100) {
          this.setState({
            contactInfo: value
          }, () => {
            suggestFields['selectType'] = 'Email';
            suggestFields[field] = value;
            this.props.validateFields(suggestFields);
          });
        }
      }
    } else if (field === 'selectType') {
      suggestFields[field] = value;
      suggestFields['contactInfo'] = '';
      this.props.validateFields(suggestFields);
      this.setState(prevState => ({
        err: {
          ...prevState.err,
          charityContact: ''
        }
      }))
    }
  }

  goBack() {
    if (this.props.redirectTo === '/grants/grant-agreement') {
      let isGemini = isGeminiUser();
      if (isGemini) {
        this.props.gaClearAllGeminiFilters();
      } else {
        this.props.gaClearAllFilters();
      }
      history.push({
        pathname: this.props.redirectTo,
        state: {
          ein: this.state.ein
        }
      })
    } else {
      history.push({
        pathname: '/grants/find-charity',
        state: {
          ein: this.state.ein
        }
      })
    }
  }

  postCharity() {
    const { suggestPost, getPageTitle, suggestBtnText } = this.props;
    initiateTracking('suggestCharity', getPageTitle(), '', suggestBtnText);

    if (this.state.isPost) {
      this.setState({
        showPopUp: false,
        loader: true
      });

      const postData = {
        ein: this.state.ein,
        legalName: this.state.cname,
        addressLine1: this.state.addr1,
        addressLine2: this.state.addr2,
        addressLine3: this.state.addr3,
        state: this.state.state,
        city: this.state.city,
        country: this.state.country,
        zip: this.state.zipcode,
        charityContactFirstName: this.state.firstName,
        charityContactLastName: this.state.lastName,
        email: this.state.selectType === 'Email' ? this.state.contactInfo : '',
        phoneNumber: this.state.selectType === 'Phone' ? this.state.contactInfo : ''
      }

      const data = {
        method: "POST",
        page: "Sac",
        url: `/donor-portal/api/granteeOrg/${getPrimaryAccount().userId}/suggestCharity`,
        data: postData
      }
      this.props.postCharity(data);
    } else {
      this.setState({
        showEinPopUp: false
      });

      if ((!suggestPost.granteeOrgs && suggestPost.savedCharitieList && suggestPost.savedCharitieList.length > 0) ||
        (!suggestPost.savedCharitieList && !suggestPost.granteeOrgs && suggestPost.granteeOrgAliasId > 0)) {
        this.goBack();
      } else if (suggestPost.granteeOrgs && suggestPost.granteeOrgs.length > 0) {
        this.addToCharity(suggestPost.granteeOrgs[0].granteeOrgId, suggestPost.granteeOrgs[0].legalName);
      }
    }
  }

  suggestCharity() {
    try {
      const { contactName, contactInfo, selectType } = this.state;
      if (!contactName && !contactInfo && !selectType)
        this.setState({ showPopUp: true, isPost: true });
      else
        this.postCharity();
    } catch (error) {
      recordError(error);
    }
  }

  closeModal() {
    this.setState({
      showPopUp: false,
      showEinPopUp: false,
      showMulEinPopUp: false,
      isPost: true
    })
  }

  addToCharity = (grantOrgId, aliasName) => {
    this.props.addToSavedCharity({
      method: 'PUT',
      url: `/donor-portal/api/grant/${getPrimaryAccount().userId}/addCharity `,
      data: {
        granteeOrgId: grantOrgId,
        alias: aliasName
      }
    })
  }

  componentWillUnmount() {
    this.props.clearCharityList('');
  }

  render() {
    const {
      err,
      country,
      state
    } = this.state;

    const { countryList, statesList, valid, suggestPost, suggestTitle, suggestBtnText, backBtnText } = this.props;
    const childProps = {
      addCharity: this.addToCharity.bind(this),
      charityList: suggestPost && suggestPost.granteeOrgs && suggestPost.granteeOrgs.length > 0 ? suggestPost.granteeOrgs : [],
      clearList: this.clearCharityList.bind(this)
    }

    return ( 
      <SACContainer data-test="charityBlock1">
          <AlertBox
            show={this.state.showPopUp}
            field_page="Suggest Charity"
            name="Contact"
            primaryBtnEvent={()=> this.postCharity()}
            secondaryBtnEvent={this.closeModal.bind(this)}            
            defaultContent={this.contactPopUp}
          />

          <AlertBox
            show={this.state.showEinPopUp}
            field_page="Suggest Charity"
            name="Ein Match"
            primaryBtnEvent={()=> this.postCharity()}
            secondaryBtnEvent={this.closeModal.bind(this)}                      
            defaultContent={this.einPopUp}
          />

          <AlertBox
            show={this.state.showMulEinPopUp}
            field_page="Suggest Charity"
            name="Multiple Charities"
            primaryBtnEvent={()=> {
              this.elemRef.scrollIntoView({ behavior: "smooth" })
              this.setState({
                showMulEinPopUp: false
              })
            }}                        
            defaultContent={this.einMulPopUp}
          />         
          <FixedWidth>
            <BreadcrumbComponent breadcrumbRoutes={this.props.breadCrumb()} />
          </FixedWidth>
          <FixedWidth>
            <PagesHeading marginBottom="15px">            
            <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Suggest Charity" property="field_page_title" defaultMessage={suggestTitle} setTitle={this.props.setPageTitle}/>
          </PagesHeading>
          <AboutCharity>
            <ContentMessage messageId="SACMsg" type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} page="Suggest Charity" property="description__value" defaultMessage="<p>Can't find the charity you're looking for? Let us help. Fill in the fields -- the more you add, the better. We'll do our due diligence and be in touch if we have any questions. (Charities added here will appear on your saved charities list.)</p>" />
          </AboutCharity>
          <Limiter />
          <CharityDetailsHeading>Charity Details</CharityDetailsHeading>
          <div>
            <Groups style={{ display: "flex" }}>
              <Detail>
                <CharityLabel>Charity Name</CharityLabel>
                <CharityInput
                  type="text"
                  name="cname"
                  id="txtcname"
                  aria-label="Enter Charity Name"
                  data-test="data-txtcname"
                  ref={this.charityName}
                  onBlur={this.handlecName}
                  value={this.state.cname}
                  onChange={(e) => this.validation(e.target.value, 'cname')}
                  placeholder="Enter Charity Name"
                />
                {err.cname ? (
                  <ErrorMessage>{err.cname}</ErrorMessage>
                ) : (
                    <NoWarning>''</NoWarning>
                  )}
              </Detail>
              <Detail>
                <CharityLabel>
                  Employer Identification Number (EIN) (optional)
                  </CharityLabel>
                <CharityInput
                  type="text"
                  aria-label="Enter EIN"
                  data-test="data-ein"
                  onChange={(e) => this.validation(e.target.value, 'ein')}
                  placeholder="Enter EIN"
                  value={this.state.ein}
                  id="ein"
                  name="ein"
                  onBlur={this.handleEIN}
                />
                {err.ein ? (
                  <ErrorMessage>{err.ein}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </Detail>
            </Groups>
            <Groups style={{ display: "flex" }}>
              <AddrDetail>
                <AddresstTitle>Address</AddresstTitle>
                <CharityLabel>Address Line 1</CharityLabel>
                <CharityInput
                  style={{ width: "100%" }}
                  onChange={(e) => this.validation(e.target.value, 'addr1')}
                  ref={this.addr1}
                  name="addr1"
                  id="txtaddr1"
                  data-test="data-addr1"
                  aria-label="Enter Address Line 1"
                  value={this.state.addr1}
                  onBlur={this.handleAddr}
                  placeholder="Enter Address Line 1"
                />
                {err.addr1 ? (
                  <ErrorMessage>{err.addr1}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
                <CharityLabel addr>Address Line 2 (optional)</CharityLabel>
                <CharityInput
                  style={{ width: "100%" }}
                  name="addr2"
                  id="txtaddr2"
                  data-test="data-addr2"
                  aria-label="Enter Address Line 2"
                  onChange={(e) => this.validation(e.target.value, 'addr2')}
                  value={this.state.addr2}
                  onBlur={this.handleAddr2}
                  placeholder="Enter Address Line 2"
                />
                {err.addr2 ? (
                  <ErrorMessage>{err.addr2}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
                <CharityLabel addr>Address Line 3 (optional)</CharityLabel>
                <CharityInput
                  style={{ width: "100%" }}
                  name="addr3"
                  id="txtaddr3"
                  data-test="data-addr3"
                  aria-label="Enter Address Line 3"
                  value={this.state.addr3}
                  onChange={(e) => this.validation(e.target.value, 'addr3')}
                  onBlur={this.handleAddr3}
                  placeholder="Enter Address Line 3"
                />
                {err.addr3 ? (
                  <ErrorMessage>{err.addr3}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </AddrDetail>
            </Groups>
            <Groups pad style={{ display: "flex" }}>
              <Detail>
                <CharityLabel style={{ paddingBottom: 5 }}>
                  Country
                  </CharityLabel>
                <ConfigProvider renderEmpty={() => (<div><p>No Results</p></div>)}>
                  <SelectBox
                    role={false}
                    showSearch
                    defaultValue={country}
                    value={country}
                    aria-label="Select Country"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .startsWith(input.toLowerCase())}
                    onChange={this.handleCountry}
                    placeholder="Select Country"
                  >
                    {countryList &&
                      countryList.map((item, index) => (
                        <Option value={item.value} key={index}>
                          {item.desc}
                        </Option>
                      ))}
                  </SelectBox>
                </ConfigProvider>
              </Detail>
              <Detail>
                <CharityLabel>Zip Code</CharityLabel>
                <CharityZipcode
                  className="charityInput"
                  isUS={country === '0'}
                  name='zipcode'
                  ariaLabel="Enter Zipcode"
                  id="txtzipcode"
                  data-test="data-zipcode"
                  placeholder='Zipcode'
                  maxLength={country === '0' && '20'}
                  title='zipcode'
                  onBlur={this.handlezip}
                  onChange={(e) => this.validation(e.target.value, 'zipcode')}
                  value={this.state.zipcode}
                />
                {err.zipcode ? (
                  <ErrorMessage>{err.zipcode}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </Detail>
            </Groups>
            <Groups pad style={{ display: "flex" }}>
              <Detail>
                <CharityLabel>City</CharityLabel>
                <CharityInput
                  ref={this.city}
                  name="city"
                  id="txtcity"
                  data-test="data-city"
                  aria-label="Enter City"
                  onChange={(e) => this.validation(e.target.value, 'city')}
                  value={this.state.city}
                  onBlur={this.handleCity}
                  placeholder="Enter City"
                />
                {err.city ? (
                  <ErrorMessage>{err.city}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </Detail>
              <Detail>
                <CharityLabel >State</CharityLabel>
                {
                  this.state.showStateInput ? (
                    <CharityInput
                      ref={this.stateInput}
                      name="state"
                      aria-label="Enter State"
                      data-test="data-stateInput"
                      onChange={(e) => this.validation(e.target.value, 'stateInput')}
                      value={this.state.state}
                      onBlur={this.handleStateInput}
                      placeholder="Enter State"
                    />
                  ) :
                    (
                      <ConfigProvider renderEmpty={() => (<div><p>No Results</p></div>)}>
                        <SelectBox
                          className="charityStateField"
                          role={false}
                          style={{ marginTop: 5 }}
                          showSearch
                          value={state ? state : undefined}
                          aria-label="Select State"
                          data-test="data-stateInput2"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .startsWith(input.toLowerCase())}
                          onChange={this.handleStates}
                          onBlur={() => this.handleSelectBlur(state, 'state')}
                          placeholder="Select State">
                          {statesList &&
                            statesList.map((item, index) => (
                              <Option value={item.value} key={index}>
                                {item.desc}
                              </Option>
                            ))}
                        </SelectBox>
                      </ConfigProvider>
                    )
                }
                {err.state ? (
                  <ErrorMessage>{err.state}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </Detail>
            </Groups>
            <Limiter />
            <CharityDetailsHeading className="contact">
              Contact Person Details
              </CharityDetailsHeading>
            <Groups pad style={{ display: "flex" }}>
              <Detail>
                <CharityLabel style={{ paddingBottom: 5 }}>First Name (optional)</CharityLabel>
                <CharityInput
                  name="charityContact"
                  id="txtcharityContact1"
                  aria-label="Enter First Name"
                  data-test="data-charityContact"
                  onChange={(e) => this.validation(e.target.value, 'firstName')}
                  value={this.state.firstName}
                  onBlur={(e) => this.handleFirstName(e)}
                  placeholder="Enter First Name"
                />
                {err.firstName ? (
                  <ErrorMessage>{err.firstName}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </Detail>
              <Detail>
                <CharityLabel style={{ paddingBottom: 5 }}>Last Name (optional)</CharityLabel>
                <CharityInput
                  name="charityContact"
                  id="txtcharityContact2"
                  aria-label="Enter Last Name"
                  data-test="data-charityContact2"
                  onChange={(e) => this.validation(e.target.value, 'lastName')}
                  value={this.state.lastName}
                  onBlur={(e) => this.handleLastName(e)}
                  placeholder="Enter Last Name"
                />
                {err.lastName ? (
                  <ErrorMessage>{err.lastName}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </Detail>
            </Groups>
            <Groups pad style={{ display: "flex" }}>
              <Detail>
                <CharityLabel aria-label="Select CharityName" style={{ paddingBottom: 5 }}>
                  Charity Contact
                    </CharityLabel>
                <SelectBox
                  role={false}
                  onBlur={() => this.handleSelectBlur(this.state.selectType, 'selectType')}
                  placeholder="Select Type"
                  data-test="data-selType"
                  id="selType"
                  onChange={this.handleDropper}>
                  <Option value="Phone">Phone Number</Option>
                  <Option value="Email">Email Address</Option>
                </SelectBox>
                {err.selectType ? (
                  <ErrorMessage>{err.selectType}</ErrorMessage>
                ) : (
                    <NoWarning>' ' </NoWarning>
                  )}
              </Detail>
              <Detail>
                <NoLabel className="freeSpace">' '</NoLabel>
                <CharityInput
                  name="contact"
                  id="txtcontact"
                  data-test="data-contact"
                  aria-label="Enter Contact Details"
                  onChange={(e) => this.validation(e.target.value, 'contactInfo')}
                  placeholder="Enter Contact Details"
                  onBlur={this.handleContact}
                  value={this.state.contactInfo}
                />
                {err.charityContact ? (
                  <ErrorMessage>{err.charityContact}</ErrorMessage>
                ) : (
                    <NoWarning className="freeSpace">' ' </NoWarning>
                  )}
              </Detail>
            </Groups>
            <Limiter />
          </div>
          <AboutCharity>
            <Note>
              <span>Note</span>
              <br /> <br />
              <ContentMessage type={[Types.PAGE_NOTICES]} html={true} page="Suggest Charity" property="field_notice_content" defaultMessage={`<p>We send all grants to the organization's full legal name as registered with the IRS. This name may differ from its "doing business as" name. Likewise the organization's legal address may differ from its preferred address for receiving donations. Please add the organization's full legal name and mailing address where it accepts donations.</p>`} />
            </Note>
          </AboutCharity>
          <div
            ref={(el) => this.elemRef = el}
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "50px 0px"
            }}
          >
            <GeneralButton
              id="btnbackBtn"
              type="functional"
              data-test="data-backBtn"
              onClick={() => this.state.recommandGrant()}
              text={backBtnText}
              width="177px"
              mobWidth="40%"
              inverted={true}
              styling="suggestACharityStyle m0"
            />
            {valid && !childProps.charityList.length && !this.state.loader ? (
              <GeneralButton
                id="btnsuggestBtn1"
                type="functional"
                onClick={this.suggestCharity}
                width="177px"
                mobWidth="40%"
                text={suggestBtnText}
                styling="suggestACharityStyle m0"
              />
            ) : (
                <GeneralButton id="btnsuggestBtn2"
                  type="functional"
                  text={this.state.loader ? <Preloader styling="btnLoader" /> : suggestBtnText }
                  width="177px"
                  mobWidth="40%"
                  styling="suggestACharityStyle m0"
                  disabled={true}
                />
              )}
          </div>
          {
            suggestPost && suggestPost.granteeOrgs && suggestPost.granteeOrgs.length > 0
            && <Row>
              <Col lg={24} md={24} sm={0} xs={0}>
                <AddCharityWeb {...childProps} />
              </Col>
              <Col lg={0} md={0} sm={24} xs={24}>
                <AddCharityMobile {...childProps} />
              </Col>
            </Row>
          }
        </FixedWidth>
      </SACContainer>
    );
  }
}

SuggestACharity.propTypes = {
  getPageTitle: PropTypes.func,
  validate: PropTypes.func,
  setPageTitle: PropTypes.func,
  breadCrumb: PropTypes.func,
  redirectTo: PropTypes.string,
  suggestTitle: PropTypes.string,
  suggestBtnText: PropTypes.string,
  backBtnText: PropTypes.string
}

const mapStateToProps = (state) => ({
  ...suggestAcharityDerivedStates(state.toJS())
})

export const mapDispatchToProps = (dispatch) => ({
  getDropDownMapping: (data) => dispatch(receiveDropDownValues(data)),
  validateFields: (data) => dispatch(validateFields(data)),
  clearValidation: (data) => dispatch(clearValidation(data)),
  postCharity: (data) => dispatch(postCharity(data)),
  changeEinPopUpStatus: (data) => dispatch(changeEinPopUpStatus(data)),
  addToSavedCharity: (data) => dispatch(addToSavedCharity(data)),
  clearCharityList: (data) => dispatch(clearCharityList(data)),
  flushZipCode: () => dispatch(flushZipCode()),
  gaClearAllFilters: () => dispatch(gaClearAllFilters()),
  gaClearAllGeminiFilters: () => dispatch(gaClearAllGeminiFilters())
})

export default connect(mapStateToProps, mapDispatchToProps)(SuggestACharity);